/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { PlatformError } from '../Errors';
import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/** */
export interface PlayerPackageInterface {
    /**
     * **Feature:** Retrieve list of locally stored player packages that can be
     * reinstalled
     * @throws {Error}
     * @throws {@link PlatformError}
     */
    getInstalledPackages(): Promise<Array<InstalledPackage>>;

    /**
     * **Feature:** Have player download and execute player package
     * @throws {Error}
     * @throws {@link PlatformError}
     */
    deployPackage(
        notificationChannel: string,
        playerUuid: string,
        guid: string,
        version: string,
        purgeDownloadedPackage: boolean
    ): Promise<void>;
}

export type InstalledPackage = {
    /* eslint-disable @typescript-eslint/naming-convention */
    Guid: string;
    Name: string;
    VersionAsString: string;
    Description: string;
    /* eslint-enable @typescript-eslint/naming-convention */
};

export function supportsPlayerPackage(platform: unknown): platform is PlayerPackageInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PlatformMessage.PlayerPackagesInstalled) &&
            platform.supportsMessage(PlatformMessage.PlayerPackagesDeploy)
        );
    }

    return (
        platform instanceof Object &&
        'getInstalledPackages' in platform &&
        'deployPackage' in platform
    );
}
